module.exports = __webpack_public_path__ + "img/apple_pay.8ef67f52.svg";